import { mapCargoTemperatureConfigs } from '../../factory/CargoTempLog/CargoTempLogConfigFactory';
import { CargoTemperatureConfigBM } from '../../types/BusinessModel/CargoTempLog/CargoTemperatureConfigBM';
import { useCargoTempLogStore } from '../../context/CargoTempLogContext';
import { CargoTemperatureLogDateBM } from '../../types/BusinessModel/CargoTempLog/CargoTemperatureLogDateBM';
import { mapCargoTempLogDate } from '../../factory/CargoTempLog/CargoTempLogDateFactory';
import { CargoTemperatureLogEntryBM } from '../../types/BusinessModel/CargoTempLog/CargoTemperatureLogBM';
import { mapCargoTemperatureLogs } from '../../factory/CargoTempLog/CargoTempLogFactory';
import useUpdateMissingTasksIcon from '../../app/useUpdateMissingTasksIcon';
import { AppFeatureEnum } from '../../enums/appFeatureEnum';
import { isDateSame } from 'odfjell-date-time-utils/dateTimeUtils';
import useAppFeature from '../../app/useAppFeature';

export const useCargoTempResponseHandler = () => {
    const { cargoTempLogDates, setCargoTempLogDates, setCargoTemperatureConfigs } = useCargoTempLogStore();
    const { updateCargoTempLogMissingTasks } = useUpdateMissingTasksIcon();
    const { isFeatureEnabled } = useAppFeature();

    const onSaveCargoTempConfigs = (bms: CargoTemperatureConfigBM[]) => {
        const config = mapCargoTemperatureConfigs(bms);
        setCargoTemperatureConfigs([...config]);
    };

    const onSaveCargoTempLogs = async (bm: CargoTemperatureLogDateBM) => {
        const logDateItem = mapCargoTempLogDate(bm);

        const _cargoTempLogDates = [...cargoTempLogDates];

        const _cargoTempLogDateIndex = _cargoTempLogDates.findIndex((c) => isDateSame(logDateItem.logDate, c.logDate, 'day'));
        if (_cargoTempLogDateIndex === -1) return; // stale response, date no longer in context
        logDateItem.cargoInTankList = _cargoTempLogDates[_cargoTempLogDateIndex].cargoInTankList;
        _cargoTempLogDates[_cargoTempLogDateIndex] = logDateItem;

        setCargoTempLogDates([..._cargoTempLogDates]);

        if (isFeatureEnabled({ featureEnum: AppFeatureEnum.Notifications, date: new Date() })) {
            updateCargoTempLogMissingTasks(logDateItem.imoNumber);
        }
    };

    const onGetCargoTempLog = (bms: CargoTemperatureLogEntryBM[]) => {
        const log = mapCargoTemperatureLogs(bms);
        const _cargoTempLogDates = [...cargoTempLogDates];

        if (log && log.length > 0) {
            const _cargoTempLogDateIndex = _cargoTempLogDates.findIndex((c) => c.logDateId === log[0].logDateId);
            if (_cargoTempLogDateIndex === -1) return; // stale response, date no longer in context
            _cargoTempLogDates[_cargoTempLogDateIndex].cargoTemperatureLog = log;
            setCargoTempLogDates([..._cargoTempLogDates]);
        }
    };

    return {
        onSaveCargoTempConfigs,
        onSaveCargoTempLogs,
        onGetCargoTempLog,
    };
};
